<template>
  <BaseModal
    :isShow="isMainModalShowState"
    @close="isMainModalShowState = false"
  >
    <div class="flex w-full">
      <div class="w-full laptop:w-[47%] text-black px-10 pb-10">
        <div class="font-bold">
          <div class="-mx-6 my-4">
            <IconClose
              class="cursor-pointer"
              @click="isMainModalShowState = false"
            />
          </div>
          <div class="pb-6 text-justify">
            لطفا جهت دریافت مشاوره رایگان و ثبت سفارش، فرم زیر را تکمیل نمایید
            تا همکاران ما در اسرع وقت با شما تماس بگیرند.
          </div>
          <Form
            ref="mainModalForm"
            class="w-full"
            :validation-schema="schema"
            :initial-values="initialValues"
            @submit="handleSubmit"
          >
            <BaseInput
              hasBorder
              size="full"
              name="name"
              placeholder="نام و نام خانوادگی"
            />
            <BaseInput
              hasBorder
              size="full"
              name="number"
              placeholder="شماره تماس"
              isNumber
            />
            <!-- <BaseInput
              hasBorder
              size="full"
              name="activity"
              placeholder="حوزه فعالیت (اختیاری)"
            />
            <BaseInput
              hasBorder
              size="full"
              name="companyName"
              placeholder="نام شرکت(اختیاری)"
            /> -->
            <BaseButton
              size="full"
              type="submit"
              text="ارسال درخواست"
              id="counseling_btn"
            />
          </Form>
        </div>
      </div>
      <div class="just-desktop w-[53%]">
        <div
          class="w-full h-full bg-blue-450 pt-4 text-center flex flex-col justify-between  text-white"
        >
          <div class="flex-grow font-bold flex flex-col justify-start">
            <div class="flex justify-center">
              <NuxtImg
                sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                width="1000"
                height="1000"
                src="/img/logo-modal.webp"
                format="webp"
                alt="white logo"
                class="w-32"
              />
            </div>
            <!-- <div class="mt-2">از پر کردن فرم سایت ها خسته شده اید؟</div> -->
            <div class="text-2xl">
              همین حالا با ۰۰۰۰ ۸۰ ۸۲ ۰۲۱ تماس بگیرید.
            </div>
          </div>
          <div
            class="bg-blue-800 h-1/2 pb-6 flex flex-col justify-center relative"
          >
            <div
              class="absolute w-full -top-20 h-40 flex justify-center items-center"
            >
              <NuxtImg
                sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                width="1000"
                height="1000"
                class="rounded-full !w-[9rem]"
                src="/img/img-form.webp"
                format="webp"
                alt="contact navatel"
              />
            </div>
            <div class="pt-20 px-4 text-xl text-center ">
              نواتل ابزاری قدرتمند برای ساده کردن کسب‌و‌کار شما
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
import { object, string } from 'yup'
import { Form } from 'vee-validate';

const { validateFaChar ,validateMobile }  = useInputHelpers();
const route = useRoute()

const { post, loading } = useSendMail()

const isMainModalShowState = useState('isMainModalShow')

const isSuccessModalShowState = useState('isSuccessModalShowState')

const isModalShowed = useCookie("isModalShowed")

const mainModalForm = ref(null)

setTimeout(() => {
  if (!isModalShowed.value && route.name != 'online-shopping-buy' && route.name != 'online-shopping-thankyou' && route.name != 'online-shopping-buy-internet-phone') {
    isMainModalShowState.value = true
    isModalShowed.value = true
  }
}, 120000)

const initialValues = {
  name: '',
  number: '',
  activity: '',
  companyName: ''
}
const schema = object({
  name: string()
    .required('این فیلد نباید خالی باشد.').test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
  number: string()
    .required('این فیلد نباید خالی باشد.').test("", "مقدار وارد شده معتبر نیست.", validateMobile),
  activity: string().test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
  companyName: string().test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
})
const handleSubmit = async (form, { resetForm }) => {
  if (!loading.value) {
    const { data, error } = await post({
      body: { model: form }
    })
    if (!error.value && data.value === 'ok') {
      resetForm()
      isMainModalShowState.value = false
      isSuccessModalShowState.value= true
    }
  }
}
watch(()=> isMainModalShowState.value, async(newVal)=>{
  if(newVal) {
    mainModalForm.value.resetForm();
  }
})
</script>
